import Layout from '@/components/layout/Layout.vue'
import { getMediaMaterials, changeAdMaterialStatus, deletePromotionMaterial } from '@/api/media-material'
import { getWorkers, getCorporations, getKvData } from '@/api/open'
import { getMedias } from '@/api/constant'
import moment from 'moment'
import CreateForm from '@/components/local-material/mediaRecord/create/Create.vue'

export default {
    name: 'showPromotionPage',
    components: {
        Layout,
        CreateForm,
    },
    props: {
        showPromotionPage: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        },
    },
    data() {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            data: [],
            loading: false,
            medias: [],
            columns: [
                { minWidth: 60, type: 'checkbox' },
                { minWidth: 200, title: '广告主', field: 'advertiser', slots: { default: 'advertiser' } },
                { minWidth: 230, title: '广告/创意', field: 'promotion', slots: { default: 'promotion' } },
                { minWidth: 80, title: '消耗', field: 'stat_cost', sortable: true },
                { minWidth: 130, title: '转化成本', field: 'conversion_cost', sortable: true },
                { minWidth: 90, title: '转化数', field: 'convert_cnt', sortable: true },
                { minWidth: 130, title: '付费roi', field: 'pay_amount_roi', sortable: true },
                { minWidth: 90, title: '点击率', field: 'ctr', sortable: true },
                { minWidth: 120, title: '激活单价', field: 'active_cost', sortable: true },
                { minWidth: 160, title: '当日广告变现ROI', field: 'attribution_micro_game_0d_roi', sortable: true },
                { minWidth: 160, title: '三日广告变现ROI', field: 'attribution_micro_game_3d_roi', sortable: true },
                // { minWidth: 90, title: '展示数', field: 'show_cnt', sortable: true },
                // { minWidth: 160, title: '千次展现费用', field: 'cpm_platform', sortable: true },
                // { minWidth: 90, title: '点击数', field: 'click_cnt', sortable: true },
                // { minWidth: 100, title: '平均点击', field: 'cpc_platform', sortable: true },
                // { minWidth: 90, title: '转化率', field: 'conversion_rate', sortable: true },
            ],
            queryParam: { 
                ...this.model,
                // 'date': this.model.date, corporation_id: this.model.corporation_id, advertiser_name: this.model.advertiser_name, material_id: this.model.material_id 
            },
            channels: [],
            platforms: [],
            workers: [],
            tableGrid: this.getTableGrid(),
            preview: {},
            preview_loading: false,
            filteredCorporations: [],  // 过滤后的媒体主体列表
            media_corporations: [],//媒体主体
            material_ids: null,
            selectedRowKeys: [],
            corporations: [],
            shortcutsR: [
                {
                  text: '今天',
                  onClick: () => {
                    this.queryParam.date = [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')]
                  },
                },
                {
                  text: '昨天',
                  onClick: () => {
                    const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
                    this.queryParam.date = [yesterday, yesterday]
                  },
                },
                {
                    text: '最近3天',
                    onClick: () => {
                      this.queryParam.date = [moment().subtract(3, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                    },
                },
                {
                    text: '最近5天',
                    onClick: () => {
                      this.queryParam.date = [moment().subtract(5, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                    },
                  },
                {
                  text: '最近7天',
                  onClick: () => {
                    this.queryParam.date = [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                  },
                },
                {
                  text: '最近14天',
                  onClick: () => {
                    this.queryParam.date = [moment().subtract(14, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                  },
                },
                {
                  text: '最近1个月',
                  onClick: () => {
                    this.queryParam.date = [moment().subtract(1, 'months').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                  },
                },
            ],
            showUploadForm: false,
            materialModel: {},
        }
    },
    watch: {
         
    },
    mounted() {
        this.tableGrid.columns = this.columns
        getCorporations().then(res=>{ this.corporations = res.data.list || {} })

        //此处开始获取kvData
        getKvData({type:2, corporation_id: this.model.corporation_id}).then(res => {
            this.media_corporations = res.data.list || []
            this.filteredCorporations = this.media_corporations
        })

        getWorkers().then(res => { this.workers = res.data.list || [] })
        getMedias().then(res => { this.medias = res.data.list || [] })
        this.getData()
    },
    created() {
    },
    methods: {
        checCheckboxkMethod({ row }) {
            return row.media === 2
        },
        showCheckboxkMethod({ row }) {
            return row.media === 1
        },
        handleRowChange(result) {
            this.selectedRowKeys = result.records.flatMap((item) => {
                return item.id
            })
        },
        getTableGrid() {
            let grid = this.$helper.tableGrid('mediaMaterial')
            grid.size = 'medium'
            grid.border = 'inner'
            return grid
        },
        getData() {
            if (!this.queryParam.date) {
                return this.$message.error('请选择查询日期')
            }
            this.tableGrid.loading = true
            const json = Object.assign({}, this.queryParam, {
                page: this.tableGrid.pagerConfig.currentPage,
                page_size: this.tableGrid.pagerConfig.pageSize
            })
            json['started_at'] = json.date[0]
            json['finished_at'] = json.date[1]
            json['material_id'] = this.model.material_id
            delete json.date


            getMediaMaterials(json).then(res => {
                this.tableGrid.pagerConfig.total = res.data.total
                this.tableGrid.loading = false
                this.tableGrid.data = res.data.list
                this.data = res.data.list || []
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.tableGrid.pagerConfig.currentPage = 1
            this.getData()
        },
        handlePageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize
            this.getData()
        },
        handleSortChange(data) {
            this.queryParam.sort_field = data.order ? data.field : null
            this.queryParam.sort_type = data.order
            this.getData()
        },
        accessTo(route) {
            let controller = 'MediaMaterialController'
            if (route.indexOf('@') !== -1) {
                const routeArr = route.split('@')
                controller = routeArr[0]
                route = routeArr[1]
            }
            return this.$helper.accessTo(controller, route)
        },
        close() {
            this.$emit('update:showPromotionPage', false)
        },

        changeAdMaterialStatus(id, enabled, refresh) {
            // if (this.queryParam.stat_day < '2023-11-16') {
            //     return this.$message.error('只能操作2023-11-15号后之后的数据')
            // }
            const update = ids => {
                changeAdMaterialStatus(ids, { 'status': enabled }).then(() => {
                    if (refresh) {
                        this.$message.destroy()
                        this.$message.success('操作成功')
                        this.refresh()
                    }
                }).catch(() => {
                    this.tableGrid.loading = false
                })
            }
            if (!id) {
                const actionType = enabled === 'ENABLE' ? '启用' : '暂停'
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要{actionType} {this.selectedRowKeys.length} 条广告吗?</div>,
                    onOk: () => {
                        update(this.selectedRowKeys, enabled)
                    }
                })
            }
            update([id])
        },
        changeMediaCorporation(value) {
            // 如果用户输入了内容，则按输入内容进行过滤
            if (value) {
              this.filteredCorporations = this.media_corporations
                .filter(item => item.includes(value));  // 直接过滤字符串数组
            } else {
              // 如果没有输入，则展示所有选项
              this.filteredCorporations = [...this.media_corporations]; // 显示全部选项
            }

        },
        destroyPromotionMaterial (record) {

            const del = ids => {
                this.tableGrid.loading = true
                deletePromotionMaterial( ids ).then(res => {
                    this.$message.destroy()
                    this.tableGrid.loading = false
                    if (res && res.code === 0) {
                        this.$message.success('删除成功')
                        this.refresh()
                        this.closePromotionForm()
                    } else {
                        this.$message.error(res.message)
                    }
                }).catch(() => {
                    this.tableGrid.loading = false
                })
            }
            if (!record) {
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要删除选中的 {this.selectedRowKeys.length} 条数据吗?</div>,
                    onOk: () => {
                        del(this.selectedRowKeys)
                    }
                })
            }
            // del([record.id], record.advertiser_id)
        },
        uploadToMedia (record) {
            this.showUploadForm = true
            this.materialModel = {
                media_name: '巨量',
                mediaStr: 'juliang',
                up_type: 3,
                advertiser_id: null,
                material_id: record.material_id,
                material_advertiser_id: record.advertiser_id,
            }
        },
       
    }
}
